import type { CheckoutSizes, Sizes } from '@trmediaab/zebra';

const sizes: Sizes & CheckoutSizes = {
  buttonHeights: {
    small: 30,
    xlarge: 40,
    xxlarge: 50,
  },
};

export default sizes;
